import React, {
    createContext,
    useContext,
    useEffect,
    useReducer,
    useState,
} from 'react'

import { logger } from 'utils/logger'

import { settingsReducer, initialSettings } from './settings/settingsReducer'

export const StateContext = createContext(null)

export default function AppStateProvider(props) {
    const [error, setError] = useState(null)
    const [activeSinkId, setActiveSinkId] = useState('default')
    const [settings, dispatchSetting] = useReducer(
        settingsReducer,
        initialSettings
    )

    const contextValue = {
        error,
        setError,
        activeSinkId,
        setActiveSinkId,
        settings,
        dispatchSetting,
    }

    useEffect(() => {
        error && logger.error(error)
    }, [error])

    return (
        <StateContext.Provider value={contextValue}>
            {props.children}
        </StateContext.Provider>
    )
}

export function useAppState() {
    const context = useContext(StateContext)
    if (!context) {
        throw new Error('useAppState must be used within the AppStateProvider')
    }
    return context
}
